import { Injectable } from '@angular/core';
import { LocalStorageProxy } from '@utils/local-storage-proxy';

@Injectable({
  providedIn: 'root'
})
export class CookieDomainService {
  private storage = new LocalStorageProxy('lv-cookie-domain');

  getCookieDomain(): string | null {
    return this.storage.get('name');
  }

  setCookieDomain(domain: string) {
    this.storage.set('name', domain);
  }
}
